import axios from 'axios';
import { $ } from './bling';

const primaryLat = 54.991951;
const primaryLng = -7.320572;

const mapOptions = {
	center: {
		lat: primaryLat,
		lng: primaryLng
	},
	mapTypeId: google.maps.MapTypeId.ROADMAP,
  //draggable: !("ontouchend" in document),
  scrollwheel: false,
  mapTypeControl: false,
	zoom: 12
};

function loadPlaces(map, category) {
	const url = (category) ? `/locations/${category}/json` : `/locations/all/json`;
	axios.get(url)
		.then(res => {
			const locations = res.data;
			if (!locations.length) {
				// TODO: better handling
				console.log('no locations.');
			}
			const bounds = new google.maps.LatLngBounds();
			const infoWindow = new google.maps.InfoWindow({
				maxWidth: 240
			});

			// const markerLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			// let markerLabelIndex = 0;

			const markers = locations.map(loc => {
				const [locLng, locLat] = loc.location.coordinates;
				const position = { lat: locLat, lng: locLng };
				
				// Only include map marker in initial view if it's a category map or it's not marked as excluded
				if (category != "all") {
					bounds.extend(position);
				} else {
					if (!loc.excludeFromMainMapInitialBounds) {
						bounds.extend(position);
					}
				}

				const markerColor = (loc.category.themeColor) ? '#'+loc.category.themeColor : '#253D5B';
				const icon = {
					path: "M13.9999446,7.09893145 C13.9826113,3.17794355 10.8662903,0 6.9999723,0 C3.13365427,0 0,3.17794355 0,7.09893145 C0,12.1731895 6.87716577,18 6.87716577,18 C6.87716577,18 14.0229445,12.1731895 13.9999446,7.09893145 Z M7.00009342,10 C8.65699927,10 10.0001868,8.65685425 10.0001868,7 C10.0001868,5.34314575 8.65699927,4 7.00009342,4 C5.34318758,4 4,5.34314575 4,7 C4,8.65685425 5.34318758,10 7.00009342,10 Z",
					fillColor: markerColor,
					fillOpacity: 1,
					strokeColor: '#FFFFFF',
					anchor: new google.maps.Point(7,18),
					strokeWeight: 2,
					scale: 2
				}
				let marker = new google.maps.Marker({ 
					map, 
					position, 
					//icon: '/images/icons/marker.svg',
					icon: icon,
					title: 'Location: '+loc.name,
					//label: markerLabels[markerLabelIndex++ % markerLabels.length]
				});
				marker.location = loc;
				return marker;
			});

			// var clusterStyles = {
			// 	styles: [{
			// 		url: '/images/markers/m1.svg',
			// 		textColor: 'white',
			// 		height: 60,
			// 		width: 60,
			// 		iconAnchor: [30,30],
			// 		textSize: 14
			// 	}]
			// };
			// const markerCluster = new MarkerClusterer(map, markers, clusterStyles);

			// Show details when marker is clicked
			markers.forEach(marker => marker.addListener('click', function() {
				// const html = `
				// 	<div class="popup">
				// 		<a href="/store/${this.location.slug}">
				// 			<img src="/uploads/${this.location.photo || 'store.png'}" alt="${this.location.name}" />
				// 			<p>${this.location.name} - ${this.place.location.address}</p>
				// 		</a>
				// 	</div>
				// `;
				const markerColor = (this.location.category.themeColor) ? '#'+this.location.category.themeColor : '#253D5B';
				const urlLocName = this.location.name.toLowerCase().replace(/[^a-zA-Z0-9] /g,'').replace(/ /g, '-');
				const html = `
					<div class="popup" style="margin:3px 0;">
						<strong style="display:block; color:${markerColor}; margin-bottom:2px;">${this.location.category.name}</strong>
						<a href="/things-to-do/${this.location.category.slug}${'#'+urlLocName}" style="display:block; font-size:18px; margin-bottom:8px;" rel="nofollow"><strong style="color:#444;">${this.location.name}</strong></a>
						<span>${this.location.location.address}</span>
					</div>
				`;
				infoWindow.setContent(html);
				infoWindow.open(map, this);
			}));

			new google.maps.Marker({
				map: map,
				position: new google.maps.LatLng(primaryLat, primaryLng),
        icon: '/images/icons/bridgebnb-marker.svg',
        title: 'Bridge B&B',
        zIndex: 999
			});
			bounds.extend(new google.maps.LatLng(primaryLat, primaryLng));
			//zoom map to fit markers
			//map.setCenter(bounds.getCenter());
			map.fitBounds(bounds);
		});
}

function makeMap(mapDiv, category = null) {
	if(!mapDiv) return;
	// make our map
	const map = new google.maps.Map(document.getElementById(mapDiv), mapOptions);
	loadPlaces(map, category);

	// const input = $('[name="geolocate"]');
	// const autocomplete = new google.maps.places.Autocomplete(input);
	// autocomplete.addListener('place_changed', () => {
	// 	const place = autocomplete.getPlace();
	// 	loadPlaces(map, place.geometry.location.lat(), place.geometry.location.lng());
	// });
}

export default makeMap;


// WEBPACK FOOTER //
// ./public/javascripts/modules/map.js